/**
 * 커스텀 견적서 접근 판정.
 *
 * **판정은 서버가 한다** — `user/info` 응답의 `is_custom_estimate_tester`.
 * 명단은 어드민(관리 > 커스텀견적서 테스터)에서 관리하므로, 여기 이메일을 적어 넣고
 * 재배포하는 방식은 더 쓰지 않는다. 아래 하드코딩은 **서버가 값을 안 줄 때의 폴백**
 * 으로만 남긴다(구버전 백엔드·응답 누락 시 메뉴가 통째로 사라지지 않게).
 *
 * dk-cost 쪽 같은 게이트: src/app/service/api.service.ts isCustomEstimateTester()
 */
export const CUSTOM_ESTIMATE_OPEN = false; // 운영: 내부 테스터만

const TESTER_DOMAINS = ["ddukeong.com"];
const TESTER_EMAILS = ["ddk@ddukeong.com", "expert01@ddukeong.com"];

export const isCustomEstimateTester = (
  email?: string | null,
  serverFlag?: boolean | null
): boolean => {
  // 서버가 판정해 줬으면 그대로 따른다 (어드민 명단이 여기 반영된다)
  if (typeof serverFlag === "boolean") return serverFlag;
  if (CUSTOM_ESTIMATE_OPEN) return true;
  const e = (email || "").trim().toLowerCase();
  if (!e) return false;
  const domain = e.split("@")[1] || "";
  if (TESTER_DOMAINS.includes(domain)) return true;
  return TESTER_EMAILS.includes(e);
};
